import { connect, FormikProps } from 'formik'
import { Flex, MuiDatePicker, Text } from '@pinchenterprisesnpm/friday-ui'
import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import { selectOriginalShift } from '@src/data/FullEditShift/selectors'
import { CustomValidationError } from '@src/features/shift-post-v2/style'
import {
  DateText,
  FloatingLabel,
  IconWrapper,
  LeftIconWrapper,
  StyledIcon,
  TriggerContainer,
  TriggerContent,
} from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/components/single-day-picker/single-day-picker.style'
import { faCalendar } from '@fortawesome/pro-solid-svg-icons'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import { useState } from 'react'
import { useSelector } from 'react-redux'

const { DatePickerSingle } = MuiDatePicker

interface ISingleDayPickerProps {
  formik?: FormikProps<IScheduleSectionFormValues>
  isDisabled: boolean
  customWidth?: string
}

export const SingleDayPicker = connect<ISingleDayPickerProps>(
  ({ formik, isDisabled, customWidth }) => {
    const { values, setFieldValue, errors } = formik
    const [isOpen, setIsOpen] = useState(false)

    const originalShift = useSelector(selectOriginalShift)

    const shiftHasPunchCards = !!Number(originalShift?.stats?.punch_cards_count)
    const isDisabledFinal = shiftHasPunchCards || isDisabled

    const hasValue = !!values.single_day_date
    const hasError = !!errors.single_day_date && typeof errors.single_day_date === 'string'

    // Create a function component for the trigger that accepts children
    const TriggerElement = ({ children, onClick, ...props }: any) => (
      <TriggerContainer
        isFocused={isOpen}
        hasError={hasError}
        onClick={isDisabledFinal ? () => {} : onClick}
        isDisabled={isDisabledFinal}
        customWidth={customWidth}
        {...props}
      >
        <FloatingLabel hasValue={hasValue} isFocused={isOpen}>
          Select Date
        </FloatingLabel>
        <TriggerContent>
          <LeftIconWrapper>
            <StyledIcon icon={faCalendar} />
          </LeftIconWrapper>
          {hasValue && <DateText>{children}</DateText>}
          <IconWrapper>
            <StyledIcon icon={faChevronDown} />
          </IconWrapper>
        </TriggerContent>
      </TriggerContainer>
    )

    return (
      <Flex flexDirection='column'>
        <Text mb='xs' fontWeight='normal'>
          Select Date
        </Text>

        <DatePickerSingle
          triggerElement={<TriggerElement />}
          isDisabled={isDisabledFinal}
          selectedDay={values.single_day_date}
          onDayClick={(day) => {
            setFieldValue('single_day_date', day)
          }}
          onReset={() => setFieldValue('single_day_date', undefined)}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
        />

        {errors.single_day_date && typeof errors.single_day_date === 'string' ? (
          <CustomValidationError mt='xs' mb={0}>
            {errors.single_day_date}
          </CustomValidationError>
        ) : null}
      </Flex>
    )
  }
)
